// Anmeldung bei Keycloak — Authorization Code Flow mit PKCE.
//
// Die App ist ein oeffentlicher Client: Sie laeuft im Browser und kann kein
// Geheimnis verwahren. PKCE ersetzt es; oidc-client-ts erzeugt Verifier und
// Challenge (S256) von sich aus, der Realm verlangt genau das.
//
// Alle Werte kommen aus der Umgebung und werden BEIM BAUEN eingesetzt (Create
// React App). Siehe .env.example.
import { WebStorageStateStore } from 'oidc-client-ts';

const keycloakUrl = (process.env.REACT_APP_KEYCLOAK_URL || '').replace(/\/+$/, '');
const realm = process.env.REACT_APP_KEYCLOAK_REALM || 'openki';

if (!keycloakUrl) {
  console.error(
    'REACT_APP_KEYCLOAK_URL ist nicht gesetzt — die Anmeldung kann nicht starten. ' +
    'Siehe .env.example.'
  );
}

// Die Adresse muss exakt der sein, die Keycloak in die Tokens schreibt
// (iss-Claim). Browser und BFF muessen Keycloak unter derselben URL sehen,
// sonst weist der BFF jedes Token als "falscher Aussteller" ab.
export const AUTHORITY = `${keycloakUrl}/realms/${realm}`;

// Muss unter den Redirect-URIs des Clients stehen. Der Bootstrap setzt sie aus
// KEYCLOAK_REACT_APP_REDIRECT_URIS; die Vorgabe dort endet auf /*, deckt diesen
// Pfad also ab.
const redirectUri = `${window.location.origin}/login`;

export const CLIENT_ID = process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'react-app';
export const POST_LOGOUT_REDIRECT_URI = redirectUri;

// Keycloaks eigene Kontoverwaltung. Dort liegt das Feld "Organisation" aus der
// Registrierung: Das Benutzerprofil des Realms gibt es mit edit-Recht fuer
// "user" frei, die Person darf es also selbst aendern. Gebraucht wird der Weg
// in genau einem Fall — der eingetragene Name war beim Einrichten des
// Arbeitsbereichs schon vergeben, und ohne ihn endet die Anmeldung dort.
export const ACCOUNT_CONSOLE_URL = `${AUTHORITY}/account/#/personal-info`;

// Der Notausgang unter /logout baut die Abmeldeadresse selbst, weil er auch
// dann noch funktionieren muss, wenn oidc-client-ts keinen brauchbaren
// Zustand mehr hat und signoutRedirect nichts zu senden faende.
export const endSessionUrl = ({ idToken = '' } = {}) => {
  const url = new URL(`${AUTHORITY}/protocol/openid-connect/logout`);
  url.searchParams.set('post_logout_redirect_uri', POST_LOGOUT_REDIRECT_URI);
  // Ohne id_token_hint verlangt Keycloak die Angabe des Clients, sonst weist
  // es post_logout_redirect_uri ab und zeigt seine eigene Abschlussseite.
  // Mit dem Hint entfaellt zusaetzlich die Bestaetigungsseite.
  if (idToken) url.searchParams.set('id_token_hint', idToken);
  else url.searchParams.set('client_id', CLIENT_ID);
  return url.toString();
};

export const oidcConfig = {
  authority: AUTHORITY,
  client_id: CLIENT_ID,
  redirect_uri: redirectUri,
  post_logout_redirect_uri: redirectUri,
  response_type: 'code',

  // "organization" traegt die Attribute der Keycloak-Organisation ins Token
  // (Tenant-IDs beider Systeme). Der Bootstrap weist den Scope als Default zu;
  // ihn hier trotzdem zu nennen macht sichtbar, worauf die App angewiesen ist.
  scope: 'openid profile email organization',

  // Ohne diesen Speicher waere die Anmeldung nach jedem Neuladen weg:
  // oidc-client-ts legt sonst im sessionStorage ab.
  userStore: new WebStorageStateStore({ store: window.localStorage }),

  // Erneuert das Token still im Hintergrund, bevor es ablaeuft.
  automaticSilentRenew: true,

  // Nach der Rueckkehr von Keycloak stehen ?code= und ?state= in der Adresse.
  // Ohne dieses Aufraeumen blieben sie stehen und ein Neuladen versuchte, den
  // bereits eingeloesten Code ein zweites Mal einzutauschen.
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
